import {
  Flex,
  RadioListInput,
  useAsyncFunctionProgress,
  useFormConfigurationContext,
  useUserHasOneOfRoles,
} from '@equifinance/shared';
import styled from 'styled-components';
import {
  OfferType,
  useChecklistContext,
} from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';
import EsigSection from './Sections/Esig';
import PostalSection from './Sections/Postal';
import { LinkButton } from '../../common';

const OfferSectionWrapper = styled(Flex)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};
  gap: ${theme.padding[5]};
  align-items: center;
`}`;

const CancelIcon = styled.i`${({ theme }) => `
  color: ${theme.colours.link[1]};
  padding-right: ${theme.padding[1]};
  font-size: ${theme.fontSize[3]};
  display: inline-block;
  transform: scaleX(-1);
`}`;

export default function OfferSection() {
  const { checklist, cancelOffer } = useChecklistContext();
  const { isDisabled } = useFormConfigurationContext();

  const { sendOffer } = checklist ?? {};
  const { offer, possibleOfferTypes } = sendOffer ?? {};

  const order = Object.keys(OfferType);
  const orderPossibleOfferTypes = [...(possibleOfferTypes ?? [])]
    ?.sort((a, b) => order.indexOf(a) - order.indexOf(b))
    ?.reduce((prev, current) => ({
      ...prev,
      [current]: current,
    }), {}) ?? {};

  const onCancelOffer = async () => {
    if (isDisabled) return;
    await cancelOffer();
  };

  const { inProgress, execute: executeCancelOffer } = useAsyncFunctionProgress(onCancelOffer);

  const disableCancelOffer = (!useUserHasOneOfRoles(['CAN_OFFER_CASE', 'UNDERWRITER'])) || inProgress;

  return (
    <GenericSection
      subSection={ChecklistSection.SEND_OFFER_OFFER}
      level={1}
    >
      <OfferSectionWrapper>
        <RadioListInput
          field="sendOffer.offer.offerType"
          label="Type of signature:"
          options={orderPossibleOfferTypes}
          required
          labelOverride={{
            'Esig': 'eSig',
            'Postal': 'Wet signature',
          }}
          disabled={!offer?.canChangeType}
        />
        {(offer?.offerType && !['Complete', 'Expired', 'Cancelled'].includes(offer.status)) && (
          <Flex>
            <LinkButton disabled={disableCancelOffer} onClick={executeCancelOffer}>
              <CancelIcon className="mi-refresh" />
              Cancel Offer
            </LinkButton>
          </Flex>
        )}

      </OfferSectionWrapper>

      {offer?.offerType === 'Esig' && (<EsigSection />)}
      {offer?.offerType === 'Postal' && (<PostalSection />)}

    </GenericSection>
  );
}
